import { render, staticRenderFns } from "./SupplierArchives.vue?vue&type=template&id=55033a84&scoped=true&"
import script from "./SupplierArchives.vue?vue&type=script&lang=ts&"
export * from "./SupplierArchives.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierArchives.vue?vue&type=style&index=0&id=55033a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55033a84",
  null
  
)

export default component.exports